import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[hideIcon]',
})
export class HideIconDirective {

  @Input() hideIcon: boolean;

  constructor(private el: ElementRef) {
    this.hideIcon = true;
  }
  
  ngOnChanges() {
    if (this.hideIcon == true) {
      this.el.nativeElement.style.display = 'none';
    } else if (this.hideIcon == false) {
      this.el.nativeElement.style.display = 'inline-block';
    }
  }
}
